import Model, { belongsTo } from "@ember-data/model";
import type Medic from "parog-web/models/medic";
import type Patient from "parog-web/models/patient";
export default class MedicsPatient extends Model {
  @belongsTo("medic", {
    async: false,
    inverse: null
  })
  declare medic: Medic;
  @belongsTo("patient", {
    async: false,
    inverse: "medicsPatients"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medics-patient": MedicsPatient;
  }
}
